const errorActionsPrefix = "error";

export const errorActions = {
  RESPONSE_ERROR: `${errorActionsPrefix}/response`,
  JAVASCRIPT_ERROR: `${errorActionsPrefix}/javascript`,

  MODAL_CLOSE: `${errorActionsPrefix}/modal-close`,
};
